type AttributeWithLabelProps = {
  className?: string;
  label?: string;
  labelClassName?: string;
  value: string;
  valueClassName?: string;
  defaultValue?: string;
};

function AttributeWithLabel({
  className,
  label,
  labelClassName,
  value,
  valueClassName,
}: AttributeWithLabelProps) {
  return (
    <div data-testid="attribute-with-label" className={className}>
      {label && <div className={labelClassName}>{label}</div>}
      <div className={valueClassName}>{value}</div>
    </div>
  );
}

export default AttributeWithLabel;
